import React, {PropsWithChildren} from 'react';
import clsx from 'clsx';

import WithBorder from '../WithBorder';

import styles from './PaymentSupportItem.module.css';


export interface PaymentSupportProps extends PropsWithChildren<{}> {
  className?: string
  itemClassName?: string
  src?: string
  isFull: boolean
  additionalText?: string

  onClick?: () => void
}


const PaymentSupportItem = (
  {
    src,
    isFull,
    children,
    className,
    itemClassName,
    additionalText,
    onClick
  }: PropsWithChildren<PaymentSupportProps>) => {

  const borderStyle = isFull ? 'none' : '0.5px solid #DDDDDD';

  return (
    <div
      className={clsx(styles.root, className)}
      onClick={onClick}
    >
      <WithBorder
        className={clsx(styles.item, isFull && styles.itemFull, itemClassName)}
        borders="top left right bottom"
        borderStyle={borderStyle}
      >
        {src && <img className={clsx(styles.img, isFull && styles.isFull)} src={src} alt="payment support"/>}
        <span>
          {children}
        </span>
      </WithBorder>
      {
        additionalText &&
        <div className={styles.additionalText}>
          {additionalText}
        </div>
      }
    </div>
  );
};

export default PaymentSupportItem;